// TODO Get these from server
const VEHICLE_INFO_CATEGORIES = ['be', 'c1', 'c1e', 'c', 'ce', 'd1', 'd1e', 'd', 'de'];

export function hasVehicleInfo(category) {
  return VEHICLE_INFO_CATEGORIES.includes(category);
}

